import { Form, FormProps, message } from "antd";
import api from "common/api";
import { IAchievement } from "common/types/achievements";
import { INews } from "common/types/news";
import { FieldData } from "rc-field-form/es/interface";
import React, { FC, createContext, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Context = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const onFinish: FormProps["onFinish"] = async (values) => {
    try {
      const payload = {
        ...values,
      };
      const response = await api.achievements.addAchievement(payload, id);
      message.success("Natija yaratildi");
      navigate(-1);
    } catch (err) {
      console.log(err);
    }
  };

  const getById = async (id: string) => {
    try {
      const response = await api.achievements.getById(id);
      const fields: FieldData[] = (
        Object.keys(response.data) as (keyof IAchievement)[]
      ).map((key) => ({
        name: key,
        value:
          key === "comment"
            ? {
                uz: response.data[key].uz,
                ru: response.data[key].ru,
                en: response.data[key].en,
              }
            : response.data[key],
      }));
      form.setFields(fields);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async () => {
    if (id)
      try {
        const response = await api.achievements.delete(id);
        message.success("Natija o'chirildi");
        navigate(-1);
      } catch (err) {
        console.log(err);
      }
    else navigate(-1);
  };

  useEffect(() => {
    if (id) getById(id);
  }, []);

  return {
    state: { form },
    actions: { onFinish, handleDelete },
  };
};

const AchievementsAddContext = createContext<any>({ state: {}, actions: {} });

export const AchievementsAddContextProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const value = Context();
  return (
    <AchievementsAddContext.Provider value={value}>
      {children}
    </AchievementsAddContext.Provider>
  );
};

export default function useAchievementsAddContext() {
  return useContext<ReturnType<typeof Context>>(AchievementsAddContext);
}
